export const assetContentsResponseDefaults = {
  bucketKey: '',
  createdAt: 0,
  id: 0,
  portalId: 0,
  scopes: [],
  themePath: ''
};